import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';

import { useTheme } from '@/theme';

interface LoadingPageProps {
  message?: string;
}

const LoadingPage: React.FC<LoadingPageProps> = ({ message = 'Loading...' }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: theme.hhglobal.purpose.fillWeak,
        gap: 3,
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{
          color: theme.hhglobal.brand.secondary.skyBlue,
        }}
      />
      <Typography
        sx={{
          fontSize: 18,
          fontWeight: 500,
          color: theme.hhglobal.purpose.textWeak,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingPage;
